module.exports = __webpack_public_path__ + "exo-latin-600italic.88502b7cff2e54cebf90.woff";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-600italic.woff
// module id = ../../../../typeface-exo/files/exo-latin-600italic.woff
// module chunks = styles